import { callApi } from '../api'

export async function getStatesByCountry(countryId: string | number) {
	const r = await callApi(`/countries/${countryId}/states`, {})

	if (!r.ok) throw Error(r.payload?.data?.message)
	return r.payload.data.states
}
